"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/Domains/actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _Domain = _interopRequireDefault(require("./Domain"));

var _handleActions;

var initialState = (0, _immutable.Map)({
  allDomains: (0, _immutable.Map)(),
  blogDomains: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchDomainsActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['allDomains'], function (domain) {
    return (0, _mergeWithCollectionOfType.default)(_Domain.default, action.payload.data.objects, domain);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchBlogDomainsActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['blogDomains'], function (domain) {
    return (0, _mergeWithCollectionOfType.default)(_Domain.default, action.payload.data.objects, domain);
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;